export default {
  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0])).CUTOFF

      this.setData = this.rawData
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.revision   = json.revision
      this.system     = json.system
      this.handover   = json.handover
      this.innerSVG   = json.innerSVG
      this.search     = json.search

      this.sundries   = json.sundries
      this.keys       = json.keys
      this.filters    = json.filters

      this.Boundary = this.Boundary + `${this.revision}/`

      this.current = {handover: 'OVERALL', sys: null, list: 'JPG', page: 1}
      this.filteringData()

      this.handover.forEach(d=> {
        if(d.code =='OVERALL') d.count = this.rawData.length
        else d.count = this.rawData.filter(f=> f.SYS_CODE == d.code).length
      })


      
    },



    filteringData() {
      if(this.current.handover == 'OVERALL') this.setData = this.rawData
      else this.setData = this.rawData.filter(f=> f.SYS_CODE == this.current.handover)

      if(this.search.input) {

        // let find_Tag = this.itrData.filter(f => f.TAG_NO.includes(this.search.input))
        // let tagList = [ ...new Set(find_Tag.map(m => m.SYS)) ]

        this.setData = this.setData.filter(f => f.SYS.toLowerCase().includes(this.search.input.toLowerCase()))

        // tagList.forEach(d=> {
        //   if(!this.setData.find(f=> f.SYS==d)) this.setData.push(this.rawData.find(f=> f.SYS == d))
        // })
      }
    },

  }
}